import type { WebViewerInstance, Core } from "@pdftron/webviewer";

const SIGNATURE_KEY = "signatures";

export function configureSignatureTool(instance: WebViewerInstance, userId: number) {
  const { documentViewer } = instance.Core;
  const signatureTool = documentViewer.getTool("AnnotationCreateSignature") as Core.Tools.SignatureCreateTool;

  signatureTool.addEventListener("signatureSaved", async (e) => {
    const signatures = await signatureTool.exportSignatures(true);
    localStorage.setItem(`${SIGNATURE_KEY}_${userId}`, JSON.stringify(signatures));
  });

  signatureTool.addEventListener("signatureDeleted", async (e) => {
    const signatures = await signatureTool.exportSignatures(true);
    if (!signatures?.length) {
      localStorage.removeItem(`${SIGNATURE_KEY}_${userId}`);
      return;
    }
    localStorage.setItem(`${SIGNATURE_KEY}_${userId}`, JSON.stringify(signatures));
  });

  try {
    const storedSignatures = localStorage.getItem(`${SIGNATURE_KEY}_${userId}`);
    if (storedSignatures) {
      const signatures = JSON.parse(storedSignatures);
      documentViewer.addEventListener("documentLoaded", () => {
        signatureTool.importSignatures(signatures);
      });
    }
  } catch (error) {
    console.error("Error during signature import: ", error);
  }
}
